export const navigationHomeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M19.4654 10.5H22.6V20.25C22.6 21.4926 21.5926 22.5 20.35 22.5H15.1V14.25C15.1 13.4216 14.4284 12.75 13.6 12.75H10.6C9.77157 12.75 9.1 13.4216 9.1 14.25V22.5H3.85001C2.60736 22.5 1.6 21.4926 1.60001 20.25L1.60003 10.5H4.37165C4.94683 10.5 5.47136 10.1711 5.72189 9.65334L7.48963 6L16.3475 6L18.1152 9.65334C18.3657 10.1711 18.8903 10.5 19.4654 10.5Z"
      fill="currentColor"
    />
    <path
      d="M1.60005 3.74999C1.60005 2.50736 2.60741 1.5 3.85005 1.5H20.35C21.5926 1.5 22.6 2.50736 22.6 3.75V9L19.4654 9L17.6977 5.34666C17.4472 4.8289 16.9226 4.5 16.3475 4.5H7.48964C6.91445 4.5 6.38992 4.8289 6.1394 5.34666L4.37165 9H1.60004L1.60005 3.74999Z"
      fill="currentColor"
    />
  </svg>
);

export const navigationPlayersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M16.1466 14.8538C16.2788 15.2272 16.3741 15.6234 16.4206 16.0422C16.6097 17.744 16.6124 20.3308 16.5689 22.5H20.55C21.7926 22.5 22.8 21.4926 22.8 20.25V12.2719L21.9893 11.8297C20.7581 13.3212 19.9453 14.24 18.1506 15.3645C17.8191 15.5722 17.4023 15.5812 17.0634 15.3932C16.7314 15.2091 16.4274 15.0309 16.1466 14.8538Z"
      fill="currentColor"
    />
    <path
      d="M14.9298 16.2078C14.7741 14.8068 13.8268 13.6551 12.8069 12.8126C12.624 12.6615 12.4421 12.5232 12.2671 12.3981C11.9638 12.1814 11.681 12.0044 11.4483 11.8689C11.3958 11.8384 11.3461 11.81 11.2994 11.7839C10.047 13.3025 9.23593 14.2285 7.423 15.3645C7.09153 15.5722 6.67472 15.5812 6.33575 15.3932C5.31556 14.8275 4.55994 14.3175 3.92951 13.7218C3.39364 13.2154 2.96907 12.6668 2.55081 12.0105L1.79999 12.4347V20.25C1.79999 21.4926 2.80735 22.5 4.04999 22.5H15.0686C15.1128 20.3221 15.1077 17.8092 14.9298 16.2078Z"
      fill="currentColor"
    />
    <path
      d="M17.5923 1.5C15.678 1.5 14.1151 3.00416 14.0209 4.89503C14.0149 5.01519 14.0276 5.13536 14.0497 5.25362L14.199 6.05108C13.776 6.05108 13.4657 6.44858 13.5682 6.85892L13.8933 8.15923C13.9657 8.44865 14.2257 8.65169 14.5241 8.65169H14.6853L14.8316 9.43365C14.939 10.0081 14.7822 10.586 14.4289 11.0215C14.8467 11.6998 15.2228 12.1925 15.6873 12.6315C16.1507 13.0693 16.7267 13.477 17.5689 13.9567C18.9512 13.0618 19.6347 12.3196 20.6926 11.0438C20.1999 10.5694 19.9819 9.85796 20.1528 9.16926L20.2811 8.65169H20.6605C20.9588 8.65169 21.2189 8.44865 21.2912 8.15923L21.6163 6.85892C21.7189 6.44858 21.4086 6.05108 20.9856 6.05108H20.9262L21.1108 5.30713C21.1489 5.15351 21.1707 4.99544 21.1603 4.8375C21.0377 2.97374 19.4871 1.5 17.5923 1.5Z"
      fill="currentColor"
    />
    <path
      d="M7.18987 1.5C5.27563 1.5 3.71269 3.00416 3.61852 4.89503C3.61254 5.01519 3.62516 5.13536 3.64728 5.25362L3.79658 6.05108C3.3736 6.05108 3.06325 6.44858 3.16583 6.85892L3.49091 8.15923C3.56327 8.44865 3.82332 8.65169 4.12165 8.65169H4.28291L4.42918 9.43365C4.55475 10.1049 4.31945 10.7808 3.83144 11.2289C4.19891 11.8025 4.54388 12.2386 4.95973 12.6315C5.42306 13.0693 5.9991 13.477 6.84125 13.9567C8.28979 13.019 8.97102 12.2489 10.1197 10.8568C9.74938 10.3932 9.60072 9.7725 9.75035 9.16926L9.87874 8.65169H10.2581C10.5564 8.65169 10.8165 8.44865 10.8888 8.15923L11.2139 6.85892C11.3165 6.44858 11.0061 6.05108 10.5832 6.05108H10.5238L10.7084 5.30713C10.7465 5.15351 10.7683 4.99544 10.7579 4.8375C10.6353 2.97374 9.08467 1.5 7.18987 1.5Z"
      fill="currentColor"
    />
  </svg>
);

export const navigationEvolutionsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M6.49602 19.9401C6.59764 19.6672 6.86655 19.5 7.15778 19.5H17.8422C18.1334 19.5 18.4024 19.6672 18.504 19.9401C18.7187 20.5169 18.8433 21.1274 18.8697 21.75H6.13029C6.15666 21.1274 6.28126 20.5169 6.49602 19.9401Z"
      fill="currentColor"
    />
    <path
      d="M9.66232 16.5914L11.5855 15.75H13.4145L15.3377 16.5914C16.0872 16.9193 16.7598 17.3991 17.3134 18H7.68665C8.24019 17.3991 8.91283 16.9193 9.66232 16.5914Z"
      fill="currentColor"
    />
    <path
      d="M4.37827 14.6676C5.0228 13.8942 5.82205 13.266 6.72327 12.8226L10.6288 14.5312L9.06109 15.2171C8.06326 15.6537 7.17403 16.305 6.45682 17.1247C6.11537 17.5149 5.81821 17.9372 5.56828 18.3837C4.95392 19.4812 4.625 20.7252 4.625 22V22.5H4.12611C2.95189 22.5 2 21.5481 2 20.3739C2 18.5309 2.64615 16.7462 3.82603 15.3303L4.37827 14.6676Z"
      fill="currentColor"
    />
    <path
      d="M20.8739 22.5H20.375V22C20.375 21.9165 20.3736 21.8332 20.3708 21.75C20.3447 20.9771 20.1979 20.2184 19.9401 19.5C19.802 19.115 19.632 18.7415 19.4317 18.3837C19.3589 18.2537 19.2822 18.1257 19.2015 18C19.005 17.694 18.7852 17.4013 18.5432 17.1247C18.076 16.5908 17.5358 16.1282 16.9401 15.75C16.6214 15.5476 16.2867 15.3693 15.9389 15.2171L7.0149 11.3129C5.99421 10.8663 5.0915 10.1883 4.37827 9.33239L3.82603 8.6697C2.64615 7.25384 2 5.46914 2 3.62611C2 2.45189 2.95189 1.5 4.12611 1.5C4.40164 1.5 4.625 1.72449 4.625 2.00001C4.625 2.08349 4.62641 2.16683 4.62922 2.25C4.65531 3.02289 4.80212 3.78157 5.05986 4.5C5.19798 4.88501 5.36796 5.25845 5.56828 5.61633C5.64105 5.74634 5.71783 5.87429 5.79854 6C5.99502 6.30601 6.21479 6.59871 6.45682 6.87531C6.92402 7.40925 7.46421 7.87176 8.05986 8.25C8.37862 8.45241 8.71325 8.63069 9.06109 8.78286L17.9851 12.6871C19.0058 13.1337 19.9085 13.8117 20.6217 14.6676L21.174 15.3303C22.3539 16.7462 23 18.5309 23 20.3739C23 21.5481 22.0481 22.5 20.8739 22.5Z"
      fill="currentColor"
    />
    <path
      d="M15.3377 7.40863L13.4145 8.25H11.5855L9.66232 7.40863C8.91283 7.08073 8.24019 6.60087 7.68665 6H17.3134C16.7598 6.60087 16.0872 7.08073 15.3377 7.40863Z"
      fill="currentColor"
    />
    <path
      d="M7.15778 4.5C6.86655 4.5 6.59764 4.33281 6.49602 4.05989C6.37156 3.72559 6.27737 3.37999 6.21505 3.02727C6.1408 2.60711 6.48606 2.25 6.91273 2.25H18.0873C18.5139 2.25 18.8592 2.60711 18.785 3.02727C18.7226 3.37999 18.6284 3.72559 18.504 4.05989C18.4024 4.33281 18.1334 4.5 17.8422 4.5H7.15778Z"
      fill="currentColor"
    />
    <path
      d="M20.375 2.00001C20.375 1.72449 20.5984 1.5 20.8739 1.5C22.0481 1.5 23 2.45189 23 3.62611C23 5.46914 22.3539 7.25384 21.174 8.6697L20.6217 9.33239C19.9772 10.1058 19.178 10.734 18.2767 11.1774L14.3712 9.46875L15.9389 8.78286C16.9367 8.34631 17.826 7.69498 18.5432 6.87531C18.8846 6.48508 19.1818 6.06282 19.4317 5.61633C20.0461 4.51878 20.375 3.27481 20.375 2.00001Z"
      fill="currentColor"
    />
  </svg>
);

export const navigationSquadBuilderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M17.3958 12.75H23.2V20.25C23.2 21.4926 22.1926 22.5 20.95 22.5H17.4542V20.7C17.4542 20.2858 17.1184 19.95 16.7042 19.95H8.69577C8.28155 19.95 7.94577 20.2858 7.94577 20.7V22.5H4.44998C3.20734 22.5 2.19998 21.4926 2.19998 20.25L2.20002 12.75H8.00415C8.15974 13.743 8.62178 14.6695 9.33524 15.3911C10.2262 16.2922 11.4363 16.8 12.7 16.8C13.9637 16.8 15.1738 16.2922 16.0647 15.3911C16.7782 14.6695 17.2403 13.743 17.3958 12.75Z"
      fill="currentColor"
    />
    <path d="M15.9542 21.45V22.5H9.44577V21.45H15.9542Z" fill="currentColor" />
    <path
      d="M2.20002 3.75C2.20002 2.50736 3.20738 1.5 4.45003 1.5H7.94577V3.3C7.94577 3.71421 8.28155 4.05 8.69577 4.05H16.7042C17.1184 4.05 17.4542 3.71421 17.4542 3.3V1.5H20.95C22.1926 1.5 23.2 2.50736 23.2 3.75V11.25H17.3958C17.2403 10.257 16.7782 9.33053 16.0647 8.60891C15.1738 7.70781 13.9637 7.2 12.7 7.2C11.4363 7.2 10.2262 7.70781 9.33524 8.60891C8.62178 9.33053 8.15974 10.257 8.00415 11.25H2.20002V3.75Z"
      fill="currentColor"
    />
    <path d="M9.44577 2.55V1.5H15.9542V2.55H9.44577Z" fill="currentColor" />
    <path
      d="M10.4019 9.66353C11.0129 9.04558 11.8397 8.7 12.7 8.7C13.5603 8.7 14.3871 9.04558 14.9981 9.66353C15.6093 10.2818 15.9542 11.1221 15.9542 12C15.9542 12.8779 15.6093 13.7182 14.9981 14.3365C14.3871 14.9544 13.5603 15.3 12.7 15.3C11.8397 15.3 11.0129 14.9544 10.4019 14.3365C9.79067 13.7182 9.44577 12.8779 9.44577 12C9.44577 11.1221 9.79067 10.2818 10.4019 9.66353Z"
      fill="currentColor"
    />
  </svg>
);

export const navigationBurgerMenuIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <rect
      x="1.89999"
      y="3"
      width="22"
      height="3"
      rx="1.5"
      fill="currentColor"
    />
    <rect
      x="1.89999"
      y="10"
      width="22"
      height="3"
      rx="1.5"
      fill="currentColor"
    />
    <rect
      x="1.89999"
      y="17"
      width="22"
      height="3"
      rx="1.5"
      fill="currentColor"
    />
  </svg>
);

export const navigationTacticsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 1.5H6.75V2.25C6.75 3.49264 7.75736 4.5 9 4.5H15C16.2426 4.5 17.25 3.49264 17.25 2.25V1.5H20.25C21.4926 1.5 22.5 2.50736 22.5 3.75V20.25C22.5 21.4926 21.4926 22.5 20.25 22.5H3.75C2.50736 22.5 1.5 21.4926 1.5 20.25V3.75C1.5 2.50736 2.50736 1.5 3.75 1.5ZM20.6765 8.36579C20.9693 8.65869 20.9693 9.13356 20.6765 9.42645C20.3836 9.71935 19.9087 9.71935 19.6158 9.42645L18.375 8.18566V10.5C18.375 11.7426 17.3676 12.75 16.125 12.75H13.5C13.0858 12.75 12.75 13.0858 12.75 13.5V16.5C12.75 17.7426 11.7426 18.75 10.5 18.75H9.65549C9.32245 20.0439 8.14788 21 6.75 21C5.09315 21 3.75 19.6569 3.75 18C3.75 16.3431 5.09315 15 6.75 15C8.14788 15 9.32245 15.9561 9.65549 17.25H10.5C10.9142 17.25 11.25 16.9142 11.25 16.5V13.5C11.25 12.2574 12.2574 11.25 13.5 11.25H16.125C16.5392 11.25 16.875 10.9142 16.875 10.5V8.20337L15.6722 9.42281C15.3813 9.7177 14.9064 9.72096 14.6115 9.43008C14.3166 9.1392 14.3134 8.66434 14.6043 8.36944L17.6214 5.31069L20.6765 8.36579ZM4.71967 6.03217C5.01256 5.73928 5.48744 5.73928 5.78033 6.03217L6.75 7.00184L7.71967 6.03217C8.01256 5.73928 8.48744 5.73928 8.78033 6.03217C9.07322 6.32506 9.07322 6.79994 8.78033 7.09283L7.81066 8.0625L8.78033 9.03217C9.07322 9.32506 9.07322 9.79994 8.78033 10.0928C8.48744 10.3857 8.01256 10.3857 7.71967 10.0928L6.75 9.12316L5.78033 10.0928C5.48744 10.3857 5.01256 10.3857 4.71967 10.0928C4.42678 9.79994 4.42678 9.32506 4.71967 9.03217L5.68934 8.0625L4.71967 7.09283C4.42678 6.79994 4.42678 6.32506 4.71967 6.03217ZM16.0653 15.9697C16.3581 15.6768 16.833 15.6768 17.1259 15.9697L18.0956 16.9393L19.0653 15.9697C19.3581 15.6768 19.833 15.6768 20.1259 15.9697C20.4188 16.2626 20.4188 16.7374 20.1259 17.0303L19.1562 18L20.1259 18.9697C20.4188 19.2626 20.4188 19.7374 20.1259 20.0303C19.833 20.3232 19.3581 20.3232 19.0653 20.0303L18.0956 19.0607L17.1259 20.0303C16.833 20.3232 16.3581 20.3232 16.0653 20.0303C15.7724 19.7374 15.7724 19.2626 16.0653 18.9697L17.0349 18L16.0653 17.0303C15.7724 16.7374 15.7724 16.2626 16.0653 15.9697Z"
      fill="currentColor"
    />
    <path
      d="M6.75 19.5C5.92157 19.5 5.25 18.8284 5.25 18C5.25 17.1716 5.92157 16.5 6.75 16.5C7.57843 16.5 8.25 17.1716 8.25 18C8.25 18.8284 7.57843 19.5 6.75 19.5Z"
      fill="currentColor"
    />
    <path
      d="M15 0C15.4142 0 15.75 0.335787 15.75 0.75V2.25C15.75 2.66421 15.4142 3 15 3H9C8.58579 3 8.25 2.66421 8.25 2.25V0.75C8.25 0.335786 8.58579 0 9 0H15Z"
      fill="currentColor"
    />
  </svg>
);

export const navigationUpgradeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.2105 19.4606H9.78942V10.4606H6.4059L11.9999 4.86656L17.594 10.4606H14.2105V19.4606Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 3.75C1.5 2.50736 2.50736 1.5 3.75 1.5H20.25C21.4926 1.5 22.5 2.50736 22.5 3.75V20.25C22.5 21.4926 21.4926 22.5 20.25 22.5H3.75C2.50736 22.5 1.5 21.4926 1.5 20.25V3.75ZM3.77057 11.5522C3.64837 11.2572 3.71592 10.9176 3.9417 10.6918L11.9999 2.63359L20.0582 10.6918C20.284 10.9176 20.3515 11.2572 20.2293 11.5522C20.1071 11.8472 19.8193 12.0396 19.4999 12.0396H15.7894V21.0396H8.21047V12.0396H4.49995C4.18063 12.0396 3.89276 11.8472 3.77057 11.5522Z"
      fill="#209FF9"
    />
  </svg>
);

export const navigationMyClubIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1.5 12.1958V8.20395H10.3462V5.2999L15.7308 10.1999L10.3462 15.0999V12.1958H1.5Z"
      fill="white"
    />
    <path
      d="M12 22.4982L12.0029 22.4967C18.9869 18.9126 20.9819 14.3069 22.5 4.18942C21.0451 3.7029 20.7048 3.22438 20.4583 1.99141C17.2164 1.63414 15.3957 1.47539 12 1.50308C8.60434 1.47538 6.78362 1.63415 3.54167 1.99145C3.29524 3.22453 2.95485 3.70309 1.5 4.18964C1.64336 5.10465 1.79032 5.97501 1.94425 6.80395H8.73077V3.5499C8.73077 3.26366 8.93184 3.00627 9.23849 2.89996C9.54514 2.79366 9.89557 2.85987 10.1233 3.06714L17.203 9.5096C17.6099 9.87986 17.6099 10.5199 17.203 10.8902L10.1233 17.3327C9.89557 17.5399 9.54514 17.6061 9.23849 17.4998C8.93184 17.3935 8.73077 17.1361 8.73077 16.8499V13.5958H3.74598C5.31952 17.63 7.70219 20.249 11.9313 22.454L12 22.4982Z"
      fill="#209FF9"
    />
  </svg>
);

export const navigationMyEvolutionsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.12909 20.9428C7.5257 21.3784 6.98766 21.9027 6.53411 22.5L12.6035 22.5041C12.1961 21.8081 11.5463 21.3499 10.75 20.9428H8.12909Z"
      fill="#209FF9"
    />
    <path
      d="M9.39499 10.7389L10.5689 12.2548L6.69011 13.6297L6.08733 12.7216C5.16253 11.3284 4.66904 9.69139 4.66904 8.01696V6.14892H2.80907H0.792739H0.194205C0.0171551 6.14892 -0.0671997 5.93014 0.0636723 5.81038L0.792739 5.14324L5.64997 0.698564L6.41337 0L7.17678 0.698564L12.7631 5.81038C12.8939 5.93014 12.8096 6.14892 12.6325 6.14892H9.12179H8.1577V7.1172C8.1577 8.42904 8.59308 9.70345 9.39499 10.7389Z"
      fill="white"
    />
    <path
      d="M15.2302 17.9683L11.0428 19.3701C12.7343 20.3575 14.3235 21.4063 14.8048 22.5H19.7625C19.187 20.8626 16.333 18.328 15.2302 17.9683Z"
      fill="white"
    />
    <path
      d="M10.2733 9.26341C10.0012 8.78279 9.82288 8.25416 9.74817 7.70617H16.2593C16.0638 8.22843 15.803 8.727 15.4808 9.18928C15.4635 9.21412 15.446 9.23883 15.4284 9.26341H10.2733Z"
      fill="#209FF9"
    />
    <path
      d="M13.7335 4.59168L16.6856 4.59168V5.35077C16.6856 5.61853 16.6696 5.88503 16.638 6.14892H14.368C14.4297 5.62957 14.2642 5.07736 13.8073 4.65927L13.7335 4.59168Z"
      fill="#209FF9"
    />
    <path
      d="M20.1742 0.698564C21.4587 0.698564 22.5 1.74437 22.5 3.03443V0.698564H20.1742Z"
      fill="#209FF9"
    />
    <path
      d="M6.77621 15.5013L4.99815 16.1315C3.66076 16.6056 2.46076 17.399 1.5 18.4405V20.1641C1.5 21.4542 2.54129 22.5 3.82578 22.5H4.60104H4.6726L4.67702 22.4924C5.70601 20.7207 7.296 19.3528 9.18594 18.6017L14.1003 16.7051L15.699 16.14C17.0321 15.5845 18.2462 14.7705 19.2703 13.7418C21.3382 11.6649 22.5 8.84805 22.5 5.91087V3.03443C22.5 1.74437 21.4587 0.698564 20.1742 0.698564V0.698564C19.1038 0.698564 18.2361 1.5663 18.2361 2.63671V4.59168V5.35077C18.2361 5.61814 18.2231 5.88448 18.1976 6.14892C18.1464 6.67799 18.0445 7.19942 17.8942 7.70617C17.644 8.54981 17.2595 9.35273 16.751 10.0823C15.8443 11.3832 14.5849 12.3913 13.1263 12.9894L11.5842 13.5463L6.77621 15.5013Z"
      fill="#209FF9"
    />
  </svg>
);

export const navigationMoreIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM2.88 12.48C2.88 13.8055 3.95452 14.88 5.28 14.88C6.60548 14.88 7.68 13.8055 7.68 12.48C7.68 11.1545 6.60548 10.08 5.28 10.08C3.95452 10.08 2.88 11.1545 2.88 12.48ZM12 14.88C10.6745 14.88 9.6 13.8055 9.6 12.48C9.6 11.1545 10.6745 10.08 12 10.08C13.3255 10.08 14.4 11.1545 14.4 12.48C14.4 13.8055 13.3255 14.88 12 14.88ZM16.32 12.48C16.32 13.8055 17.3945 14.88 18.72 14.88C20.0455 14.88 21.12 13.8055 21.12 12.48C21.12 11.1545 20.0455 10.08 18.72 10.08C17.3945 10.08 16.32 11.1545 16.32 12.48Z"
      fill="currentColor"
    />
  </svg>
);

export const navigationProfileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23.5C16.0361 23.5 19.5866 21.4208 21.6387 18.275C21.4479 18.0244 21.2168 17.7833 20.9493 17.5535C20.8658 17.4817 20.774 17.42 20.6783 17.3658L16.6331 15.072L15.3432 14.2481C14.9008 13.7913 14.6936 13.1385 14.8144 12.4898L14.9636 11.6897H15.128C15.4321 11.6897 15.6972 11.4819 15.771 11.1857L16.1024 9.85521C16.2069 9.43532 15.8905 9.02859 15.4594 9.02859L15.6116 8.21259C15.6341 8.09158 15.647 7.96862 15.6409 7.84566C15.5449 5.91083 13.9515 4.3717 12.0001 4.3717C10.0486 4.3717 8.45528 5.91083 8.35928 7.84566C8.35318 7.96862 8.36605 8.09158 8.3886 8.21259L8.5408 9.02859C8.1096 9.02859 7.79321 9.43532 7.89779 9.85521L8.22919 11.1857C8.30295 11.4819 8.56806 11.6897 8.87219 11.6897H9.03659L9.1857 12.4898C9.30659 13.1385 9.09937 13.7913 8.65692 14.2481L7.36704 15.072L3.32183 17.3658C3.22611 17.42 3.13439 17.4817 3.05086 17.5535C2.7833 17.7833 2.5522 18.0245 2.36136 18.2751C4.41351 21.4208 7.96395 23.5 12 23.5Z"
      fill="currentColor"
    />
    <circle
      cx="12"
      cy="12"
      r="11"
      stroke="currentColor"
      strokeWidth="1.91304"
    />
  </svg>
);
